/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Close from "../../../components/shared/icon-cross";
import Logo from "../../../components/shared/logo";
import Button from "../../../components/shared/button";
import InputMobile from "../../shared/input-mobile";
import CarHeading from "../../shared/car-heading";
import { STEP_NAMES } from "../../../utils/funnel/steps.desktop";
import CarSubHeading from "../../shared/car-subheading";
import ButtonLink from "../../shared/button-link";
import Notification from "../../shared/notification-list";
import { sendCustomGaEvents } from "../../../tracking";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import scrollToView from "../../../utils/helpers/scroll-to-view";
import { LOCAL_STORAGE_KEYS, LOCATION_TYPE, NUMBER } from "../../../constants/app-constants";
import { getStringItem, clearItem } from "../../../utils/helpers/storage-crud";
import WarningIcon from "./images/warning.svg";
import parseCookie from "../../../utils/helpers/parse-cookie";
import { getAttributionParams } from "../../../utils/helpers/get-attributions-params";
import { kmSelectionEdit, kmSelectionPageOpen, kmSelectionPhoneForm, kmSelectiongetCarPrice } from "./tracking";

const LeadKilometerDriven = ({
    name,
    gaId,
    fetchDataConnect,
    makeLeadConnect,
    setStepConnect,
    showProceedConnect,
    updateLeadConnect,
    leadData,
    kilometersDriven,
    history,
    mobile,
    setUserMobileConnect,
    activateLastStepConnect,
    updateAPIStatusConnect,
    updateWhatsappStatusConnect,
    updateLeadSourceConnect,
    source,
    lat,
    lng,
    onCloseClick,
    pincode,
    locationSelectionType,
    setLeadScoreConnect,
    secureToken
}) => {
    const inputRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        sendCustomGaEvents(kmSelectionPageOpen);
        fetchDataConnect();
        window.setTimeout(() => {
            inputRef.current.focus();
            scrollToView(buttonRef.current);
        }, 0);
    }, [fetchDataConnect]);

    /*
        assigns priority to ab_lead_source key if present in local storage.
    */
    useEffect(() => {
        if (getStringItem(LOCAL_STORAGE_KEYS.AB_LEAD_SOURCE)) {
            updateLeadSourceConnect(getStringItem(LOCAL_STORAGE_KEYS.AB_LEAD_SOURCE));
            clearItem(LOCAL_STORAGE_KEYS.AB_LEAD_SOURCE);
        }
    }, [updateLeadSourceConnect]);
    useEffect(() => {
        window.setTimeout(() => {
            if (kilometersDriven.data && leadData.kilometersDriven.id) {
                inputRef.current.focus();
            }
        });
    }, [inputRef, kilometersDriven.data, leadData.kilometersDriven.id]);

    const onSubmit = () => {
        updateAPIStatusConnect(true);

        let firstAttributionCookie = parseCookie("first_click_attribute");
        if (firstAttributionCookie) {
            firstAttributionCookie = JSON.parse(firstAttributionCookie);
            firstAttributionCookie = firstAttributionCookie.query_param;
        }
        let lastAttributionCookie = parseCookie("last_click_attribute");
        if (lastAttributionCookie) {
            lastAttributionCookie = JSON.parse(lastAttributionCookie);
            lastAttributionCookie = lastAttributionCookie.query_param;
        }
        const sourceQuery = getAttributionParams({firstAttributionCookie, lastAttributionCookie});

        const payload = {
            make_id: leadData.brand.id,
            model_id: leadData.model.id,
            year_id: leadData.year.year_id,
            variant_id: leadData.variant.id,
            state_id: leadData.registrationState.id,
            kms: leadData.kilometersDriven.id,
            phone: mobile.toString(),
            whatsapp_consent: kilometersDriven.whatsappStatus,
            ...(locationSelectionType === LOCATION_TYPE.CURRENT && lat && lng && {
                lat, lng
            }),
            ...(leadData.ctaLocation && { cta_location: leadData.ctaLocation }),
            ...(leadData.rto && { rto_id: leadData.rto.id }),
            device_category: "Dweb",
            postal_code: pincode,
            query_params: sourceQuery,
            ...(name && name.length > NUMBER.ONE && { fullname: name }),
            ...(gaId && { ga_client_id: gaId }),
            cibil_consent: "yes",
            pvtAuth: secureToken
        };

        sendCustomGaEvents({
            ...kmSelectiongetCarPrice,
            cardetails: {
                brand: leadData.brand.displayText,
                year: leadData.year.displayText,
                variant: leadData.variant.displayText,
                state: leadData.registrationState.displayText,
                km: leadData.kilometersDriven.displayText,
                model: leadData.model.displayText
            }
        });
        setUserMobileConnect(inputRef.current.value.toString());
        const { token } = leadData;
        if (token) {
            updateLeadConnect({
                token,
                source
            }, payload).then((response) => {
                updateAPIStatusConnect(false);
                const { data } = response;
                if (data && data.detail && data.detail.score) {
                    setLeadScoreConnect(data.detail.score);
                }
                history.push(`/appointment/index?token=${token}`);
            }).catch(() => {
                updateAPIStatusConnect(false);
            });
        } else {
            makeLeadConnect({ source }, payload, secureToken).then((response) => {
                updateAPIStatusConnect(false);
                setLeadScoreConnect(response.score);
                history.push(`/appointment/index?token=${response.token}`);
            }).catch(() => {
                updateAPIStatusConnect(false);
            });
        }
    };

    const onMobileChange = (e) => {
        setUserMobileConnect(e.target.value);
    };

    const onCloseButtonClick = () => {
        onCloseClick();
        showProceedConnect();
    };

    const onEditFormClick = () => {
        sendCustomGaEvents(kmSelectionEdit);
        activateLastStepConnect(false);
        setStepConnect({ currentStep: STEP_NAMES.Brand });
        showProceedConnect();
    };

    const getButtonDisabledState = () => !(mobileNumberValidator(mobile));

    // const selectedKey = leadData.kilometersDriven && leadData.kilometersDriven.id;

    const onBlurMobileHandler = () => {
        sendCustomGaEvents({
            ...kmSelectionPhoneForm,
            form_click: "filled"
        });
    };

    const onNotificationClick = () => {
        updateWhatsappStatusConnect(!kilometersDriven.whatsappStatus);
    };

    return (
        <div id="stepTwo" className="col-12 p-0 pb-5" styleName={"styles.stepTwoContainer"} >
            <div className="row m-0" styleName={"styles.head"}>
                <div className="container">
                    <a styleName={"styles.logo"}><Logo /></a>
                    <span className="p-1 mb-0" styleName={"styles.heading"}>
                        Sell Your Car In Single Visit !
                    </span>
                    <a styleName={"closeIcon"}><Close onClickHandler={onCloseButtonClick} /></a>
                </div>
            </div>
            <div className="col-12" styleName={"styles.popoverConatiner"}>
                <div className="row m-0" styleName={"styles.blueBar"}>
                    <div className="col-6 pb-3" styleName={"styles.inner"}>
                        <div className="row m-0" styleName={"styles.detailPanel"}>
                            <p styleName={"styles.carTitle"}>
                                <CarHeading lead={leadData} />
                            </p>
                            <p styleName={"styles.carVariant"}>
                                <CarSubHeading lead={leadData} />
                            </p>
                            <div className="" styleName={"styles.editText"}>
                                <ButtonLink text="EDIT CAR DETAIL" onClick={onEditFormClick} />
                            </div>
                        </div>
                        <div className="row m-0 " styleName={"styles.kmsPanel"} >
                            <p className="ml-0" styleName={"styles.heading"}>
                                Just one more step to get car price!
                            </p>
                            {/* <p className="mb-0" styleName={"styles.carKms"}>
                                How many kilometers have you driven your car for?
                            </p> */}
                            {/* <div className="col-12 px-0 pb-4">
                                <LeadFormList
                                    items={kilometersDriven.data}
                                    onClick={onClick}
                                    labelKey={"km_display"}
                                    dataKey={"km_value"}
                                    columns={3}
                                    selectedKey={selectedKey}
                                    isLoading={kilometersDriven.isLoading}
                                />
                            </div> */}
                            <div className={`row m-0 pb-4 px-0`}>
                                <p className="mt-1 mb-3" styleName={"styles.carKms"}>
                                    Enter Mobile Number
                                </p>
                                <div className="w-100">
                                    <div className="col-6 p-0">
                                        <InputMobile
                                            onBlurCallback={onBlurMobileHandler}
                                            inputRef={inputRef}
                                            onChange={(e) => onMobileChange(e)}
                                            value={mobile}
                                        />
                                    </div>
                                    <div className={"mt-2"}>
                                        <Notification
                                            checkedStatus={kilometersDriven.whatsappStatus}
                                            onClickCallback={onNotificationClick}
                                        />
                                    </div>
                                </div>
                                <div ref={buttonRef} className="pt-2 col-6 px-0">
                                    <Button
                                        onClick={onSubmit}
                                        text="Get instant car price"
                                        isLoading={kilometersDriven.apiInProgress}
                                        disabled={getButtonDisabledState()}
                                    />
                                    <p styleName={"styles.detailText"}>
                                        We respect privacy and your information is secure with us
                                    </p>
                                    { leadData && leadData.error && leadData.error.message &&
                                        <p styleName={"styles.leadLimitAlert"}>
                                            <img src={WarningIcon} alt="warning" />
                                            {leadData.error.message}
                                        </p> }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

LeadKilometerDriven.propTypes = {
    name: PropTypes.string,
    fetchDataConnect: PropTypes.func.isRequired,
    setKilometerDrivenConnect: PropTypes.func.isRequired,
    makeLeadConnect: PropTypes.func.isRequired,
    setStepConnect: PropTypes.func.isRequired,
    showProceedConnect: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    kilometersDriven: PropTypes.object.isRequired,
    leadData: PropTypes.object.isRequired,
    mobile: PropTypes.string,
    setUserMobileConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func,
    updateLeadConnect: PropTypes.func,
    updateAPIStatusConnect: PropTypes.func,
    source: PropTypes.string,
    updateWhatsappStatusConnect: PropTypes.func,
    updateLeadSourceConnect: PropTypes.func,
    lat: PropTypes.number,
    lng: PropTypes.number,
    onCloseClick: PropTypes.func,
    cashBonus: PropTypes.object,
    selectedCity: PropTypes.object,
    pincode: PropTypes.string,
    gaId: PropTypes.any,
    locationSelectionType: PropTypes.any,
    setLeadScoreConnect: PropTypes.func,
    secureToken: PropTypes.string
};

export default LeadKilometerDriven;
